import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, Subscription, interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebServiceWorker implements OnDestroy {
  $isAnyNewUpdateAvailable: BehaviorSubject<boolean> = new BehaviorSubject(false);
  serviceSubscriptions: Subscription[] = [];

  constructor(public swUpdate: SwUpdate) {
    this.initialize();
  }

  initialize() {
    if (!this.swUpdate.isEnabled) return;

    this.serviceSubscriptions.push(
      interval(15 * 1000).subscribe(() => this.swUpdate.checkForUpdate()),
    );
    this.serviceSubscriptions.push(
      this.swUpdate.versionUpdates.subscribe((evt) => {
        if (evt.type === 'VERSION_READY') {
          this.$isAnyNewUpdateAvailable.next(true);
        }
      }),
    );
    this.serviceSubscriptions.push(
      this.swUpdate.unrecoverable.subscribe(() => {
        window.location.reload();
      }),
    );
  }

  ngOnDestroy(): void {
    this.serviceSubscriptions.forEach((sub) => sub.unsubscribe());
  }
}
